import RenderArrows from './RenderArrows'

export default RenderArrows
